module.exports = __webpack_public_path__ + "img/calc-4.311f6b85.png";